import { render, staticRenderFns } from "./importComments.vue?vue&type=template&id=43a2b2a3&scoped=true"
import script from "./importComments.vue?vue&type=script&lang=js"
export * from "./importComments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a2b2a3",
  null
  
)

export default component.exports